/**
 * Curated list of NIP-05 verification providers.
 *
 * Kept in one place so every "NIP-05 required" prompt across the app points at
 * the same up-to-date, working services. Ordered best-first.
 *
 * Note: nip05.social was removed — it is obsolete / no longer reliable.
 */

export interface Nip05Provider {
  name: string;
  /** Short human description shown under the name. */
  desc: string;
  url: string;
  /** true = has a free tier, false = paid only. */
  free: boolean;
}

export const NIP05_PROVIDERS: Nip05Provider[] = [
  {
    name: 'nostrcheck.me',
    desc: 'Free NIP-05 + media hosting',
    url: 'https://nostrcheck.me',
    free: true,
  },
  {
    name: 'nostr.directory',
    desc: 'Free NIP-05 via a tweet',
    url: 'https://nostr.directory',
    free: true,
  },
  {
    name: 'Nostr Plebs',
    desc: '~$5/yr · custom & shared domains',
    url: 'https://nostrplebs.com',
    free: false,
  },
  {
    name: 'nostr.band',
    desc: 'Paid · analytics included',
    url: 'https://nostr.band',
    free: false,
  },
];
